import { FormBuilder, FormGroup } from '@angular/forms';
import { UserModel } from 'app/models/user.model';

export type SocialLinkPayload = { title: string; url: string };

export const BANK_ACCOUNT_TYPE_OPTIONS: { value: string; label: string }[] = [
    { value: 'CC', label: 'Conta Corrente (CC)' },
    { value: 'CP', label: 'Conta Poupança (CP)' },
];

export function normalizeSocialLinks(links: SocialLinkPayload[] | null | undefined): SocialLinkPayload[] {
    return (links || [])
        .map((link) => ({
            title: (link.title || '').trim(),
            url: (link.url || '').trim(),
        }))
        .filter((link) => link.title && link.url);
}

export function patchUserProfileExtras(form: FormGroup, user: Partial<UserModel>): void {
    form.patchValue(
        {
            email_secondary: user.email_secondary ?? '',
            bank_name: user.bank_name || null,
            bank_agency: user.bank_agency ?? '',
            bank_account: user.bank_account ?? '',
            bank_account_type: user.bank_account_type ?? null,
            bank_pix: user.bank_pix ?? '',
            bank_holder: user.bank_holder ?? '',
        },
        { emitEvent: false },
    );
}

export function appendUserProfileExtrasToPayload(
    payload: Record<string, unknown>,
    form: FormGroup,
    socialLinks?: SocialLinkPayload[] | null,
): void {
    const raw = form.getRawValue();
    payload.email_secondary = raw.email_secondary || null;
    payload.bank_name = raw.bank_name || null;
    payload.bank_agency = raw.bank_agency || null;
    payload.bank_account = raw.bank_account || null;
    payload.bank_account_type = raw.bank_account_type || null;
    payload.bank_pix = raw.bank_pix || null;
    payload.bank_holder = raw.bank_holder || null;
    const links = normalizeSocialLinks(socialLinks ?? null);
    payload.social_links = links.length ? links : null;
}
